import IOverlay = ZoneIQCalibration.IOverlay;
import * as _ from 'lodash';
import { IMapper } from '../interfaces/mappers/mapper';

export class OverlayMapper implements IMapper<IOverlay, IOverlay>{
    entityProperties = [
        'Id',
        'ZoningCodeId',
        'RevisionId',
        'Name',
        'Description',
        'Priority',
        'ZoneCombinationId',
        'GridicsIdProximityType',
        'ProximityConditionId',
        'IsZoneCombinationLinkEnabled',
        'IsGeneralLinkEnabled',
        'IsUsesLinkEnabled',
        'IsParkingLinkEnabled',
        'IsOfficeLinkEnabled',
        'IsBonusLinkEnabled',
        'IsApplicabilityLinkEnabled',
        'GridicsOverlayId',
        'OldGridicsOverlayId',
        'BuildingCalibrationType',
        'BuildingTypologyMandatory',
        'Label',
        'CloneId'
    ]

    dtoProperties = this.entityProperties.concat([]);

    fromDTO(dto: IOverlay): IOverlay {
        if (!dto) {
            return null;
        }
        const result = _.pick(dto, this.entityProperties);

        return result as IOverlay;
    }

    toDTO(entity: IOverlay): IOverlay {
        if (!entity) {
            return null;
        }
        const result = _.pick(entity, this.dtoProperties);

        return result as IOverlay;
    }
}

export function overlayMapperFactory(): IMapper<IOverlay, IOverlay> {
    return new OverlayMapper();
}
